<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Select, Text, toast } from '@Shelly/shelly-design-system';
	//Services
	import { format } from 'svelte-i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Stores
	
	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let settings = $settingsStore;
	let value = settings.device.submodel;
	let cacheValue = value;
	let options = [$format('alarm_state_unknown'), '9W E27', '4.5W GU10']; //i am using this key, because i think it doesnt' worth it to create new key for one word, which is the same word
	let loading = false;
	let localIp = get_local_ip(device.id);

	const handleModelChange = async (e) => {
		value = options.indexOf(e.detail);
	};
	const saveModel = async () => {
		if (cacheValue !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					device_submodel: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: device.id,
					command: 'device_submodel',
					payload: JSON.stringify({
						device_submodel: value,
					}),
				});
			}
			if (res.isok) {
				settings.device.submodel = value;
				devices_settings.update_devices_settings(device.id, settings);
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
				cacheValue = value;
			} else {
				value = cacheValue;
				toast.open({ type: 'danger', title: $format('setting_err_toast') });
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">{$format('device_model_description')}</Text>
<Select
	size="m"
	class="mb-s"
	value={options[value]}
	{options}
	icon={'fas fa-lightbulb'}
	on:change={handleModelChange}
	id="select-xou9jqr"
	aria-label={$format('sub_settings_title_device_model', {
		default: 'Device model',
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={saveModel}
	>{$format('button_save')}</Button
>
